<template>
  <!-- 公司选择 -->
  <div class="firm">
    <div class="firmName oneHide">
      {{firm.name}}
    </div>
    <div class="line"></div>
    <div class="firmBottom">
      <div class="nameBox flexItem">
        <img src="../../../assets/img/dun.png" class="nameImg">
        <div>供应联系人</div>
        <div class="linkman oneHide">
          {{firm.user_name}}
        </div>
      </div>
      <div class="phoneBox flexItem flexB">
        <div class="phoneLeft flexItem">
          <div>供应人联系方式</div>
          <div class="phone oneHide">
            {{firm.user_phone}}
          </div>
        </div>
        <div class="phoneRight flexItem" @click="toSetFun">
          <span>修改联系资料</span>
            <img src="../../../assets/img/go.png" class="go">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    props:['firm'],
    methods: {
      // 跳转修改资料
      toSetFun(){
        // 通过子组件给父组件进行传参
        this.$emit('toSet','setsupply')
      }
    }
  }
</script>

<style>
  .firm {
    padding-top: 50px;
    width: 917px;
    height: 246px;
    background: #FFFFFF;
    box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2);
    border-radius: 20px;
    padding-bottom: 30px;
  }

  .firmName {
    width: 90%;
    font-size: 32px;
    font-weight: bold;
    color: #000000;
    line-height: 1.5;
    margin-left: 29px;
    text-align: left;
  }

  .firmBottom{
    margin-left: 22px;
    padding-right: 27px;
  }

  .nameImg {
    width: 16px;
    height: 20px;
    margin-right: 4px;
  }

  .nameBox {
    width: 500px;
    height: 15px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
  }

  .line {
    width: 100%;
    height: 1px;
    background: #EEEEEF;
    margin-bottom: 30px;
    margin-top: 30px;
  }

  .linkman {
    color: #09827B;
    margin-left: 15px;
    flex: 1;
    text-align: left;
  }

  .phoneBox {
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    margin-top: 26px;
    margin-bottom: 30px;
  }

  .phone {
    max-width: 500px;
    color: #09827B;
    margin-left: 20px;
  }

  .phoneRight {
    color: #09827B;
    cursor: pointer;
  }

  .go{
    width: 7px;
    height: 15px;
    margin-left: 7px;
  }
</style>



// WEBPACK FOOTER //
// src/components/my/supply/firm.vue